// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Fufm","container":"styles_container__3zzUO","title":"styles_title__3YPYW","wrapper":"styles_wrapper__2-jI2","answer":"styles_answer__3LwlE"};